import { render, staticRenderFns } from "./EvaluationImprovementsTreeList.vue?vue&type=template&id=52a07f1c&scoped=true&"
import script from "./EvaluationImprovementsTreeList.vue?vue&type=script&lang=js&"
export * from "./EvaluationImprovementsTreeList.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationImprovementsTreeList.vue?vue&type=style&index=0&id=52a07f1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a07f1c",
  null
  
)

export default component.exports